import React from 'react';
import { themeGet, Box, Text } from '@primer/react';
import { addAriaPropertiesOnBackgroundEls } from '../../utils/functions.js';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LTButton from '../LTButton/index.js';

var _excluded = ["actionType", "text", "type", "className", "onClick", "isCloseButton", "backgroundElementsToHide"];
var _templateObject, _templateObject2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Separator = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 1px;\n  width: 100%;\n"])), themeGet("colors.border.default"));
var Buttons = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  gap: 8px;\n  justify-content: right;\n  padding: 10px;\n"])));
var ModalFooter = function ModalFooter(_ref) {
  var footerElements = _ref.footerElements,
    returnFocusRef = _ref.returnFocusRef;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto"
    }
  }, /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(Buttons, null, footerElements === null || footerElements === void 0 ? void 0 : footerElements.map(function (_ref2, index) {
    var actionType = _ref2.actionType,
      text = _ref2.text,
      type = _ref2.type,
      className = _ref2.className,
      _onClick = _ref2.onClick,
      _ref2$isCloseButton = _ref2.isCloseButton,
      isCloseButton = _ref2$isCloseButton === void 0 ? false : _ref2$isCloseButton,
      backgroundElementsToHide = _ref2.backgroundElementsToHide,
      args = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(React.Fragment, null, type === "button" && /*#__PURE__*/React.createElement(LTButton, _extends({
      ariaLabel: text,
      actionType: actionType,
      key: index,
      className: className,
      onClick: function onClick() {
        _onClick();
        // return focus on action button triggering the modal on closing the modal
        if (isCloseButton && returnFocusRef.current) {
          addAriaPropertiesOnBackgroundEls(true, backgroundElementsToHide);
          returnFocusRef.current.focus();
        }
      }
    }, args), text), type === "message" && /*#__PURE__*/React.createElement(Text, {
      key: index
    }, text));
  })));
};
ModalFooter.displayName = "ModalFooter";
ModalFooter.defaultProps = {
  footerElements: []
};
ModalFooter.propTypes = {
  footerElements: PropTypes.arrayOf(PropTypes.object)
};

export { ModalFooter as default };
